import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"

import "./DragAndDrop.vue?vue&type=style&index=0&id=552afcc8&lang=scss"

const __exports__ = script;

export default __exports__